import reducer from './reducers';
import * as fifthAnalysesActions from './actions';
import * as fifthAnalysesSelectors from './selectors';

export { fifthAnalysesActions, fifthAnalysesSelectors };
export default reducer;
